"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (val) {
  return !val;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/milanoteLodash/not.js
// module id = 2129
// module chunks = 0